/**
 * 初始化全局api
 * @author huangyiustb
 * @modify xuxiaoyan
 */
import { initIS } from './is'
import { initApp } from './app'

let DDBridge = {}

function initGlobalAPI(DDBridge) {
  initApp(DDBridge)
  initIS(DDBridge)
}

initGlobalAPI(DDBridge)

export { DDBridge }



// WEBPACK FOOTER //
// ./src/pages/epower/bridge/ddbridge/index.js